











// Libraries
import { Component, Vue } from 'vue-property-decorator'

// Views
import HeaderView from '../layout/Header.vue'
import NavigationDrawer from '../layout/NavigationDrawer.vue'
import MatchList from '@/components/MatchList.vue'

@Component({
  components: {
    HeaderView,
    MatchList,
    NavigationDrawer,
  },
})
export default class MainLayout extends Vue {
  drawer = { state: null }
}
